const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

async function request(path, options = {}) {
    const res = await fetch(`${API_BASE_URL}${path}`, {
        ...options,
        headers: { 'Content-Type': 'application/json', ...options.headers },
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const error = new Error(body.message || '요청에 실패했습니다.');
        error.status = res.status;
        throw error;
    }
    const text = await res.text();
    if (!text) return null;
    return JSON.parse(text);
}

export const jobApplicationRepository = {
    apply: (accessToken, recruitmentRequestId, jobSeekerRequestId, message) =>
        request('/api/job-applications', {
            method: 'POST',
            headers: { Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify({ recruitmentRequestId, jobSeekerRequestId, message }),
        }),

    getMyApplications: (accessToken) =>
        request('/api/job-applications/my', {
            headers: { Authorization: `Bearer ${accessToken}` },
        }),

    getReceivedApplications: (accessToken) =>
        request('/api/job-applications/received', {
            headers: { Authorization: `Bearer ${accessToken}` },
        }),

    cancel: (id, accessToken) =>
        request(`/api/job-applications/${id}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${accessToken}` },
        }),

    checkApplied: (accessToken, recruitmentRequestId) =>
        request(`/api/job-applications/check?recruitmentRequestId=${recruitmentRequestId}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
        }),
};
